import TUMBUHImage from "../../image/tumbuhlogo.png";
import Splash02 from "../../image/spash_02.jpg";

const Theme2 = () => {
  return (
    <>
      {/* === T.U.M.B.U.H Theme Introduction === */}
      <section id="theme" className="bg-black text-white py-5">
        <div
          className="container position-relative rounded overflow-hidden"
          style={{
            backgroundImage: `url(${Splash02})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Left-side dark gradient */}
          <div
            className="position-absolute top-0 start-0 h-100"
            style={{
              width: "100%",
              background:
                "linear-gradient(to right, rgba(0,0,0,0.95) 50%, rgba(0,0,0,0.4) 80%, transparent 100%)",
              zIndex: 1,
            }}
          ></div>

          {/* Theme Introduction */}
          <div
            className="row justify-content-start"
            style={{
              position: "relative",
              zIndex: 2,
            }}
          >
            <div className="col-md-7 py-5 px-4">

              <h2 className="fw-bold fs-3 mb-3">
                T.U.M.B.U.H – Change Worth Growing
              </h2>

              <h5
                className="fw-bold mb-4"
                style={{ color: "#9ACD32" }}
              >
                Ideas Change Everything.
              </h5>

              <p
                className="mb-3"
                style={{
                  fontSize: "0.95rem",
                  lineHeight: "1.7",
                }}
              >
                Every great change begins with an idea.
                Like a seed planted in fertile soil, an idea
                has the potential to grow, inspire, and
                transform the world around us.
              </p>

              <p
                className="mb-3"
                style={{
                  fontSize: "0.95rem",
                  lineHeight: "1.7",
                }}
              >
                This year, TEDxSetapak introduces
                <strong> T.U.M.B.U.H</strong>, a theme inspired
                by the Malay word <em>"tumbuh"</em>, meaning
                <strong> "to grow."</strong>
              </p>

              <p
                className="mb-0"
                style={{
                  fontSize: "0.95rem",
                  lineHeight: "1.7",
                }}
              >
                Through six meaningful perspectives —
                <strong> Technology, Underdogs, Meals,
                Beautiful Minds, Universal, and Habitat</strong> —
                we explore how ideas can spark positive
                change and inspire us to grow together
                towards a better tomorrow.
              </p>

            </div>
          </div>
        </div>
      </section>

      {/* === T.U.M.B.U.H Framework === */}
      <section className="bg-black text-white py-5">
        <div className="container">

          <h2 className="text-center display-5 fw-bold fs-3 mb-3">
            The T.U.M.B.U.H Framework
          </h2>

          <p
            className="text-center mb-4"
            style={{
              color: "#9ACD32",
              fontSize: "1.1rem",
              fontWeight: "500",
            }}
          >
            Six Letters. One Purpose.
          </p>

{/* T.U.M.B.U.H Framework Cards */}
<div className="row g-4 justify-content-center">

  {[
    {
      letter: "T",
      title: "Technology",
      description: "Where innovation meets possibility.",
      icon: "fas fa-microchip",
      color: "#00BFFF"
    },
    {
      letter: "U",
      title: "Underdogs",
      description: "Where challenges become catalysts for change.",
      icon: "fas fa-arrow-trend-up",
      color: "#FF8C00"
    },
    {
      letter: "M",
      title: "Meals",
      description: "Because everyone deserves a seat at the table.",
      icon: "fas fa-utensils",
      color: "#FFD700"
    },
    {
      letter: "B",
      title: "Beautiful Minds",
      description: "Smarter thinking. Brighter tomorrow.",
      icon: "fas fa-brain",
      color: "#D633FF"
    },
    {
      letter: "U",
      title: "Universal",
      description: "Bridging people. Building understanding.",
      icon: "fas fa-globe",
      color: "#00BFFF"
    },
    {
      letter: "H",
      title: "Habitat",
      description: "Nurturing our planet for the future.",
      icon: "fas fa-leaf",
      color: "#9ACD32"
    }
  ].map((item, index) => (

    <div
      className="col-12 col-sm-6 col-lg-4 d-flex"
      key={index}
    >
      <div
        className="card bg-dark text-white w-100 h-100 text-center shadow"
        style={{
          border: `1px solid ${item.color}`,
          borderRadius: "15px",
          padding: "25px 20px",
          transition: "transform 0.3s ease"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-8px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >

        {/* Icon */}
        <div className="mb-3">
          <i
            className={item.icon}
            style={{
              fontSize: "2.5rem",
              color: item.color
            }}
          ></i>
        </div>

        {/* Letter */}
        <h1
          className="fw-bold mb-2"
          style={{
            fontSize: "4.5rem",
            color: item.color
          }}
        >
          {item.letter}
        </h1>

        {/* Title */}
        <h4
          className="fw-bold mb-3"
          style={{
            color: item.color,
            textTransform: "uppercase"
          }}
        >
          {item.title}
        </h4>

        {/* Description */}
        <p
          className="text-white-50 mb-0"
          style={{
            fontSize: "0.95rem",
            lineHeight: "1.6"
          }}
        >
          {item.description}
        </p>

      </div>
    </div>

  ))}

</div>

          {/* Closing Message */}
          <div className="text-center mt-4">

            <h4
              className="fw-bold mb-2"
              style={{ color: "#9ACD32" }}
            >
              Let's Grow a Better Tomorrow.
            </h4>

            <p
              className="text-white-50 mb-0"
              style={{ fontSize: "0.95rem" }}
            >
              Ideas grow with action.
            </p>

          </div>

        </div>
      </section>
    </>
  );
};

export default Theme2;